module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_12792761_S-a544bbcc947194c2f09e729590033d85.jpg";